module.exports = __webpack_public_path__ + "img/do_not_disturb_alt.d647fd28.svg";